import api from '../utils/axios';

class EmployeeDashboardService {
  // Get employee dashboard data
  static async getDashboardData() {
    try {
      const response = await api.get('/employee-dashboard/dashboard');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch dashboard data'
      };
    }
  }

  // Get employee leads
  static async getLeads(status = 'all', page = 1, limit = 10) {
    try {
      const response = await api.get('/employee-dashboard/leads', {
        params: { status, page, limit }
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching leads:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch leads'
      };
    }
  }

  // Update lead status
  static async updateLeadStatus(leadId, status, notes = '') {
    try {
      const response = await api.put(`/employee-dashboard/leads/${leadId}/status`, {
        status,
        notes
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error updating lead status:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update lead status'
      };
    }
  }

  // Add follow-up to lead
  static async addFollowUp(leadId, followUpDate, notes, priority = 'medium') {
    try {
      const response = await api.post(`/employee-dashboard/leads/${leadId}/follow-up`, {
        followUpDate,
        notes,
        priority
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error adding follow-up:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to add follow-up'
      };
    }
  }

  // Get notifications
  static async getNotifications() {
    try {
      const response = await api.get('/employee-dashboard/notifications');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch notifications'
      };
    }
  }

  // Get assigned leads with follow-ups for admin view
  static async getAssignedLeads() {
    try {
      const response = await api.get('/employee-dashboard/leads', {
        params: { status: 'all', page: 1, limit: 1000, adminView: 'true' }
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching assigned leads:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch assigned leads'
      };
    }
  }
}

export default EmployeeDashboardService;
